import 'slick-carousel';
import {AnimationService} from "../service/animation";
import FocusProductSlide from "../animations/product-slide/focus-product-slide";
import UnfocusProductSlide from "../animations/product-slide/unfocus-product-slide";
import {AbstractCarouselComponent} from "./abstract-carousel";
import EventsHandler from "../service/events";
import EVENTS from "../constants/events";

export class ProductSlidesComponent extends AbstractCarouselComponent {

    private $slides: JQuery;
    private $active: JQuery<any>;
    private events: EventsHandler;
    private animations: AnimationService;
    private currentSlide: number;
    private isMobile: boolean;
    private initialized: boolean = false;

    constructor(elem: HTMLElement) {
        super(elem);
        this.$slides = this.$root.find('.js-product-slides__slide')
    }

    init() {
        $(document).on('ixProductFilterRequestProcessed', () => this.events.emit(EVENTS.APPLICATION_RELOAD));
        this.bindSlideUI();
        this.events.addListener(EVENTS.VIEWPORT_CHANGE, this.handleViewportChange)
        let isCarousel = this.$root.data('carousel');
        if ('true' === isCarousel || undefined === isCarousel) {
            super.init();
        }
    }

    bindSlideUI = () => {
        this.$root
            .off('touchstart click')
            .on('touchstart click', '.js-product-slides__slide-pin', this.handlePin);
        this.$root
            .off('mouseover')
            .on('mouseover', '.js-product-slides__slide', this.handleMouseOver);
        this.$root
            .off('mouseout')
            .on('mouseout', '.js-product-slides__slide', this.handleMouseOut);
        this.$carousel
            .off('afterChange')
            .on('afterChange', this.handleSlideFocus);
    }

    handleViewportChange = (size:string) => {
        switch (size) {
            case 'mobile':
            case 'large_mobile':
            case 'tablet':
                this.isMobile = true;
                this.currentSlide = 0;
                if (!this.initialized) {
                    this.expand(this.getCurrentSlide());
                }
                break;
            default:
                this.isMobile = false;
                this.currentSlide = null;
                this.contractAll();
                break;
        }
        this.initialized = true;
    }

    handleSlideFocus = (ev:any, slick:JQuerySlick, currentSlide:any) => {
        if (this.isMobile && this.currentSlide != currentSlide) {
            this.contractAll();
            this.expand(this.$slides.eq(currentSlide));
            this.currentSlide = currentSlide;
        }
    }

    getTargetSlide = (ev:MouseEvent) => {
        let $slide;
        let $target = $(ev.target);
        if ($target.hasClass('js-product-slides__slide')) {
            $slide = $target;
        } else {
            $slide = $target.closest('.js-product-slides__slide');
        }
        return $slide;
    }

    getCurrentSlide = () => this.$root.find('.slick-current').find('.js-product-slides__slide');

    handlePin = (ev:any) => {
        ev.stopPropagation();
        let $slide = this.getTargetSlide(ev);
        // @ts-ignore
        (<any>window).PinUtils.pinOne({
            'url': $slide.data('url'),
            'media': $slide.data('media'),
            'description': $slide.data('description')
        });
    }

    handleMouseOver = (ev:any) => {
        if (!this.isMobile) {
            let $slide = this.getTargetSlide(ev);
            this.$active = $slide;
            !$slide.data('waiting') && this.waitForAnimation($slide).then(() => this.expand($slide));
        }
    }

    handleMouseOut = (ev:any) => {
        let $slide = this.getTargetSlide(ev);
        this.$active = null;
        setTimeout(() => {
            if (!$slide.is(this.$active)) {
                !$slide.data('waiting') && this.waitForAnimation($slide).then(() => this.contract($slide));
            }
        }, 200);
    }

    waitForAnimation = ($slide:JQuery<any>) => {
        return new Promise((resolve) => {
            if (!$slide.data('animated')) {
                resolve(true);
            } else {
                $slide.data('waiting', true);
                let waiting = setInterval(() => {
                    if (!$slide.data('animated')) {
                        resolve(true);
                        $slide.data('waiting', false);
                        clearInterval(waiting);
                    }
                }, 100);
            }
        });
    }

    expand = ($slide:JQuery<any>) => {
        if ('false' === $slide.attr('aria-expanded')) {
            $slide.data('animated', true);
            this.animations
                .run(FocusProductSlide, $slide)
                .then(() => {
                    $slide.attr('aria-expanded', 'true');
                    $slide.data('animated', false);
                })
            ;
        }
    }

    contract = ($slide:JQuery<any>) => {
        if ('true' === $slide.attr('aria-expanded')) {
            $slide.data('animated', true);
            this.animations
                .run(UnfocusProductSlide, $slide)
                .then(() => {
                    $slide.attr('aria-expanded', 'false');
                    $slide.data('animated', false);
                })
            ;
        }
    }

    contractAll = () => {
        this.$slides.each((number, element) =>
            this.contract($(element)));
    }

    setEventHandler(events:EventsHandler) {
        this.events = events;
        return this;
    }

    setAnimationHandler(animations:AnimationService) {
        this.animations = animations;
        return this;
    }

    getBaseStyleClass() {
        return 'l-product-slider';
    };

    getBaseJSClass() {
        return 'js-product-slides';
    };

    getSlickParams = () => ({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        fade: false,
        dots: false,
        autoplay: false,
        nextArrow: this.$scrollNext,
        prevArrow: this.$scrollPrev,
        appendArrows: this.$controls,
        adaptiveHeight: false,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
        ]
    });
}
